import React, { SVGProps } from 'react'

const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg width={10} height={6} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.175 0 5 3.709 8.825 0 10 1.141 5 6 0 1.141 1.175 0Z" fill="#fff" />
  </svg>
)

export default ArrowDown
